import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import Organization from '../models/organization/organization.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private ORGANIZATION_MODULES_URL: string = environment.BASE_URL + 'organization/module';
  private API_URL: string = environment.BASE_URL + 'organization';
  private PUBLIC_API_URL: string = environment.BASE_URL + 'public/organization';

  constructor(private http: HttpClient) {
  }

  getOrganizationModules(): Observable<string[]> {
    return this.http.get<string[]>(this.ORGANIZATION_MODULES_URL);
  }

  public getOrganization(handle: string, authenticated: boolean = true): Observable<Organization> {
    if (authenticated) {
      return this.http.get<Organization>(this.API_URL + '/' + handle);
    }
    return this.http.get<Organization>(this.PUBLIC_API_URL + '/' + handle);
  }


  public updateOrganization(id: string, organization: Organization): Observable<Organization> {
    return this.http.patch<Organization>(this.API_URL + '/' + id, organization);
  }
}
